import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faXTwitter,
  faFacebook,
  faInstagram,
  faReddit,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="grid-container">
          <div className="company-info">
            <h3>Dealigense Marketing</h3>
            <p className="company-description">
              Empowering businesses with personalized social media management and
              strategic digital transformation.
            </p>
          </div>

          <div className="legal-links">
            <h4>Legal</h4>
            <div className="links-container">
              <Link to="/terms" className="footer-link">
                Terms of Service
              </Link>
              <Link to="/privacy" className="footer-link">
                Privacy Policy
              </Link>
            </div>
          </div>

          <div className="social-links">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="https://x.com/dealigense" className="social-icon" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61561146107342" className="social-icon" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://www.instagram.com/dealigense/" className="social-icon" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.reddit.com/r/dealigense/" className="social-icon" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faReddit} />
              </a>
              <a href="https://www.youtube.com/channel/UCSjyeNypNu6tLn8bmcO3eeA" className="social-icon" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>
        </div>

        <div className="copyright">
          <p>© {new Date().getFullYear()} Dealigense Marketing - All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;